import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
  ResponsiveContainer, LabelList,
} from "recharts";

// ─── StackedHorizontalBarChart ────────────────────────────────────────────────
//  Gráfico de barras horizontais empilhadas, reutilizável para qualquer módulo:
//  cada linha (categoryKey) é dividida em N segmentos (segments), com legenda,
//  tooltip e rótulo de valor dentro de cada segmento.
//
//  data:       [{ [categoryKey]: 'Cliente X', backlog_2026: 100, backlog_2027: 50 }, ...]
//  segments:   [{ dataKey: 'backlog_2026', name: 'Backlog 2026', color: '#2a78d6' }, ...]
//  C:          tema (border, text, muted, card)

export function StackedHorizontalBarChart({
  data,
  categoryKey,
  segments,
  valueFormatter = (v) => v,
  height,
  categoryWidth = 150,
  C,
}) {
  const chartHeight = height ?? Math.max(240, data.length * 48);

  return (
    <ResponsiveContainer width="100%" height={chartHeight}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{ top: 8, right: 48, left: 8, bottom: 8 }}
        barCategoryGap="30%"
      >
        <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke={C.border} />
        <XAxis
          type="number"
          tickFormatter={valueFormatter}
          tick={{ fill: C.muted, fontSize: 11 }}
        />
        <YAxis
          type="category"
          dataKey={categoryKey}
          tick={{ fill: C.text, fontSize: 11 }}
          width={categoryWidth}
        />
        <Tooltip
          formatter={(v, name) => [valueFormatter(v), name]}
          contentStyle={{
            background: C.card, border: `1px solid ${C.border}`,
            borderRadius: 8, fontSize: 12,
          }}
        />
        <Legend
          verticalAlign="top"
          align="right"
          wrapperStyle={{ fontSize: 12, paddingBottom: 8 }}
        />
        {segments.map((seg, i) => (
          <Bar
            key={seg.dataKey}
            dataKey={seg.dataKey}
            name={seg.name}
            stackId="stack"
            fill={seg.color}
            barSize={22}
            radius={i === segments.length - 1 ? [0, 4, 4, 0] : [0, 0, 0, 0]}
          >
            <LabelList
              dataKey={seg.dataKey}
              position="inside"
              formatter={(v) => (v ? valueFormatter(v) : "")}
              style={{ fontSize: 10, fontWeight: 700, fill: "#fff" }}
            />
          </Bar>
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
}
